module.exports = __webpack_public_path__ + "img/gsndc2782_2.6932bb2b.svg";